import { useState } from 'react';
import { styled } from '@mui/system';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import DiamondLine from '../DiamondLine';
import NoteCardsSection from '../NoteCardsSection';
import NoteCard from '../NoteCard';
import TabPanel from './CustomTabPanel';

const TabContext = styled('div')({
  width: '100%',
});

const CustomTabs = styled(Tabs)({
  minHeight: 'auto',
  '& .MuiTabs-flexContainer': {
    justifyContent: 'center',
  },
  '& .MuiTabs-indicator': {
    display: 'none',
  },
});

const CustomTab = styled(Tab)(({ theme }) => ({
  fontFamily: 'Fjalla One',
  fontWeight: 400,
  fontSize: '20px',
  lineHeight: '30px',
  color: '#99989A',
  border: 'none',
  padding: '0 17px',
  minHeight: 'auto',
  minWidth: '95px',

  '&.Mui-selected': {
    color: '#AA9178',
  },
  '&+&': {
    borderLeft: '2px solid #AA9178',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '17px',
    lineHeight: '24px',
    padding: '0 13px',
    minWidth: '80px',
  },
}));

const TabTitleSection = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: '30px',
  justifyContent: 'center',
  flexWrap: 'wrap',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '1060px',
  margin: '0 auto',
  [theme.breakpoints.down('xs')]: {
    gap: '18px',
  },
}));

const NoteTabsGroup = ({ postedNotesData, savedNotesData }) => {
  const [tabValue, setTabValue] = useState(0);

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  return (
    <TabContext>
      <TabTitleSection>
        <DiamondLine />
        <CustomTabs
          value={tabValue}
          onChange={(event, newValue) => setTabValue(newValue)}
          aria-label="tabs"
        >
          <CustomTab label="Posted" {...a11yProps(0)} />
          <CustomTab label="Saved" {...a11yProps(1)} />
        </CustomTabs>
      </TabTitleSection>

      <TabPanel value={tabValue} index={0}>
        <NoteCardsSection>
          {postedNotesData.map((data, key) => (
            <NoteCard key={key} {...data} />
          ))}
        </NoteCardsSection>
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <NoteCardsSection>
          {savedNotesData.map((data, key) => (
            <NoteCard key={key} {...data} />
          ))}
        </NoteCardsSection>
      </TabPanel>
    </TabContext>
  );
};

export default NoteTabsGroup;
